// extracted by mini-css-extract-plugin
export var closeButton = "_d9-1";
export var closeX = "_d9-3";
export var container = "_d9-0";
export var image = "_d9-2";